module.exports = __webpack_public_path__ + "img/arrow-down-small.a33350a9.svg";